import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';
import { isAPICatchError } from '@/utils/utils';

@Component({
    name: 'users-details',
    components: {},
})

export default class RosterUserDetails extends Vue {

    // -------------------------------------------------------------------
    // Properties
    @Prop()
    private rosterData: any;

    private usersList: any = [];

    private isLoading: boolean = false;

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;


    public created() {

        this.isLoading = true;
        this.fetchUserlist();
    }


    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions
    private onClose() {
        this.$emit('onClose');
    }

    private onSelectPage(item: number) {
        this.isLoading = true;
        this.currentPage = item;
        this.offset = (item - 1) * this.pageLimit;
        this.fetchUserlist();
    }

    // ---------------------------------------------------------------------
    // Methods
    private fetchUserlist() {
        const params = {
            zipId: this.rosterData.id,
            offset: this.offset,
            limit: this.pageLimit,
            is_required_sync: this.rosterData.showError,
        };

        rosterAPI.getRosterUsers(params).then((usersList) => {
            this.isLoading = false;
            if (!isAPICatchError(usersList)) {
                this.usersList = usersList.users;
                this.totalLength = usersList.totalUsersCount;
            }
        });
    }
}
